import React from 'react';
import { motion } from 'framer-motion';
const prizes = [{
  src: 'https://cdn.magicpatterns.com/uploads/8WxQMM1dKT4dHLMt89FoR3/648640976_2139413770165907_3515969024872706095_n.jpg',
  alt: 'Claw machine packed with colorful character plushies',
  span: 'sm:col-span-2 sm:row-span-2'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/pWzK47FxMov3bnNQ2wKbEJ/649230596_1625470771980275_5650840803073813293_n.jpg',
  alt: 'Close-up of plushies waiting to be won inside a claw machine',
  span: ''
}, {
  src: 'https://cdn.magicpatterns.com/uploads/bLB972pjbJcizNg2tU8G1T/649044726_4340590886203682_5347093428057183770_n.jpg',
  alt: 'Families playing claw machines under neon lights',
  span: ''
}, {
  src: 'https://cdn.magicpatterns.com/uploads/psRLaxDJGeC1tuTTYR71jb/Screenshot_2026-06-19_at_5.01.34_PM.png',
  alt: 'Glowing Claw Planet Arcade storefront entrance',
  span: 'sm:col-span-2'
}];
export function PrizeGallery() {
  return <section id="prizes" className="relative w-full py-20 sm:py-28" data-id="element-127">
      <div className="mx-auto max-w-7xl px-4 sm:px-6" data-id="element-128">
        <div className="mb-12 text-center" data-id="element-129">
          <h2 className="font-arcade text-4xl sm:text-5xl" data-id="element-130">
            <span className="neon-pink" data-id="element-131">PRIZE</span>{' '}
            <span className="neon-cyan" data-id="element-132">GALAXY</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl font-display text-purple-100/80" data-id="element-133">
            Hundreds of plushies, characters, and surprises orbiting our
            machines — fresh prizes restocked all the time.
          </p>
        </div>

        <div className="grid auto-rows-[180px] grid-cols-2 gap-4 sm:auto-rows-[220px] sm:grid-cols-4" data-id="element-134">
          {prizes.map((p, i) => <motion.figure key={p.src} initial={{
          opacity: 0,
          scale: 0.92
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.45,
          delay: i * 0.08
        }} whileHover={{
          scale: 1.02
        }} className={['group relative overflow-hidden rounded-2xl border-2 border-purple-500/40', 'shadow-[0_0_18px_rgba(168,85,247,0.35)] transition-shadow duration-300', 'hover:border-cyan-300/70 hover:shadow-[0_0_30px_rgba(34,211,238,0.6)]', p.span].join(' ')} data-id="element-135">
              <img src={p.src} alt={p.alt} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-136" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#05010f]/60 via-transparent to-transparent" data-id="element-137" />
            </motion.figure>)}
        </div>
      </div>
    </section>;
}